export default __webpack_public_path__ + "static/media/carouselLandscape20.9bd66891.jpg";